/**
 * Ask Paul Videos - loads from Cloudflare Worker (no Liquid metaobject limit)
 */
(function () {
  var PLAY_ICON_SVG =
    '<svg viewBox="0 0 68 48" width="68" height="48">' +
    '<path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="#f00"/>' +
    '<path d="M45 24 27 14v20" fill="#fff"/>' +
    '</svg>';

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function youtubeFeaturedThumb(videoId) {
    return (
      'https://img.youtube.com/vi/' +
      escapeHtml(videoId) +
      '/maxresdefault.jpg'
    );
  }

  function featuredThumbFallback(img) {
    if (img.dataset.thumbStep === 'max') {
      img.dataset.thumbStep = 'hq';
      img.src = img.src.replace('maxresdefault', 'hqdefault');
      return;
    }
    if (img.dataset.thumbStep === 'hq') {
      img.dataset.thumbStep = 'sd';
      img.src = img.src.replace('hqdefault', 'sddefault');
    }
  }

  function buildFeatured(video, badgeText) {
    return (
      '<div class="ask-paul-videos__featured" data-video-item data-video-id="' +
      escapeHtml(video.id) +
      '" data-video-title="' +
      escapeHtml(video.title) +
      '">' +
      '<div class="ask-paul-videos__featured-thumbnail">' +
      '<img src="' +
      youtubeFeaturedThumb(video.id) +
      '" alt="' +
      escapeHtml(video.title) +
      '" loading="eager" data-thumb-step="max" onload="if(this.naturalWidth<=120){window.AskPaulVideos.thumbFallback(this);}">' +
      '<div class="ask-paul-videos__play-icon ask-paul-videos__play-icon--large">' +
      PLAY_ICON_SVG.replace('width="68"', 'width="100"').replace('height="48"', 'height="70"') +
      '</div></div>' +
      '<div class="ask-paul-videos__featured-info">' +
      '<span class="ask-paul-videos__featured-badge">' +
      escapeHtml(badgeText) +
      '</span>' +
      '<h3 class="ask-paul-videos__featured-title">' +
      escapeHtml(video.title) +
      '</h3>' +
      '<time class="ask-paul-videos__featured-date" datetime="' +
      escapeHtml(video.publishDate) +
      '">' +
      escapeHtml(video.dateText) +
      '</time></div></div>'
    );
  }

  function buildGridItem(video, hidden) {
    return (
      '<div class="ask-paul-videos__item' +
      (hidden ? ' ask-paul-videos__item--hidden' : '') +
      '" data-video-item data-video-id="' +
      escapeHtml(video.id) +
      '" data-video-title="' +
      escapeHtml(video.title) +
      '">' +
      '<div class="ask-paul-videos__thumbnail-wrap">' +
      '<img src="https://img.youtube.com/vi/' +
      escapeHtml(video.id) +
      '/mqdefault.jpg" alt="' +
      escapeHtml(video.title) +
      '" class="ask-paul-videos__thumbnail" loading="lazy">' +
      '<div class="ask-paul-videos__play-icon">' +
      PLAY_ICON_SVG +
      '</div></div>' +
      '<h3 class="ask-paul-videos__title">' +
      escapeHtml(video.title) +
      '</h3>' +
      '<time class="ask-paul-videos__date" datetime="' +
      escapeHtml(video.publishDate) +
      '">' +
      escapeHtml(video.dateText) +
      '</time></div>'
    );
  }

  function bindInteractions(section) {
    var showMoreBtn = section.querySelector('[data-show-more]');
    var modal = section.querySelector('[data-video-modal]');
    var iframe = section.querySelector('[data-video-iframe]');
    var modalTitle = section.querySelector('[data-modal-title]');
    var closeButtons = section.querySelectorAll('[data-close-modal]');
    var increment = 10;

    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', function () {
        var hiddenItems = section.querySelectorAll('.ask-paul-videos__item--hidden');
        var shown = 0;

        for (var i = 0; i < hiddenItems.length; i++) {
          if (shown < increment) {
            hiddenItems[i].classList.remove('ask-paul-videos__item--hidden');
            shown++;
          }
        }

        if (section.querySelectorAll('.ask-paul-videos__item--hidden').length === 0) {
          showMoreBtn.style.display = 'none';
        }
      });
    }

    section.querySelectorAll('[data-video-item]').forEach(function (item) {
      item.addEventListener('click', function () {
        iframe.src =
          'https://www.youtube.com/embed/' +
          this.dataset.videoId +
          '?autoplay=1&rel=0&playsinline=1';
        modalTitle.textContent = this.dataset.videoTitle;
        modal.style.display = 'block';
        document.body.classList.add('video-modal-open');
      });
    });

    function closeModal() {
      modal.style.display = 'none';
      iframe.src = '';
      document.body.classList.remove('video-modal-open');
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.style.display === 'block') {
        closeModal();
      }
    });
  }

  function renderVideos(section, videos) {
    var content = section.querySelector('[data-videos-content]');
    var urlParams = new URLSearchParams(window.location.search);
    var videoParam = urlParams.get('video');
    var videosBeforeHide = parseInt(section.dataset.videosBeforeHide || '11', 10);
    var list = videos.slice();

    if (videoParam) {
      var targetIndex = list.findIndex(function (v) {
        return v.id === videoParam;
      });
      if (targetIndex > 0) {
        var target = list.splice(targetIndex, 1)[0];
        list.unshift(target);
      }
    }

    if (list.length === 0) {
      content.innerHTML = '<p class="ask-paul-videos__empty">No videos available yet.</p>';
      return;
    }

    var badgeText = 'Latest Video';
    if (videoParam && list[0].id === videoParam) {
      badgeText = 'Selected Video';
    }

    var html = buildFeatured(list[0], badgeText);

    if (list.length > 1) {
      html += '<h3 class="ask-paul-videos__section-title">Previous Episodes</h3>';
      html += '<div class="ask-paul-videos__grid" data-videos-grid>';

      for (var i = 1; i < list.length; i++) {
        html += buildGridItem(list[i], i >= videosBeforeHide);
      }

      html += '</div>';
    }

    content.innerHTML = html;

    var showMoreWrap = section.querySelector('[data-show-more-wrap]');
    if (showMoreWrap) {
      showMoreWrap.style.display = list.length > videosBeforeHide ? '' : 'none';
    }

    bindInteractions(section);
  }

  function activateFallback(section) {
    var content = section.querySelector('[data-videos-content]');
    var loading = content.querySelector('[data-videos-loading]');
    var fallback = content.querySelector('[data-videos-fallback]');

    if (loading) {
      loading.remove();
    }

    if (fallback) {
      fallback.hidden = false;
      bindInteractions(section);
    }
  }

  async function initSection(section) {
    var workerUrl = section.dataset.workerUrl;
    if (!workerUrl) {
      activateFallback(section);
      return;
    }

    try {
      var response = await fetch(workerUrl, { credentials: 'omit' });
      if (!response.ok) {
        throw new Error('Failed to load videos');
      }

      var data = await response.json();
      if (!data.videos || !data.videos.length) {
        throw new Error('No videos returned');
      }

      var loading = section.querySelector('[data-videos-loading]');
      if (loading) {
        loading.remove();
      }

      renderVideos(section, data.videos);
    } catch (error) {
      console.warn('Ask Paul worker unavailable:', error);
      var content = section.querySelector('[data-videos-content]');
      var loading = section.querySelector('[data-videos-loading]');
      if (loading) {
        loading.remove();
      }
      if (content) {
        content.innerHTML =
          '<p class="ask-paul-videos__empty">Videos are temporarily unavailable. Please refresh in a few minutes.</p>';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-videos-section]').forEach(initSection);
  });

  window.AskPaulVideos = { thumbFallback: featuredThumbFallback };
})();
